import { Injectable, Signal, inject } from '@angular/core';
import { APP_ACTIONS, type AppActionsApi } from '@app/core/app.actions';
import { RxState } from '@rx-angular/state';
import { Navigation } from 'app/core/navigation/navigation.types';

interface INavigationState {
  navigation: Navigation;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationState extends RxState<INavigationState> {
  protected readonly appActions: AppActionsApi = inject(APP_ACTIONS);

  navigation: Signal<Navigation> = this.signal('navigation');

  constructor() {
    super();
    this.hold(this.appActions.resetAll$, () => {
      this.reset();
    });
  }

  reset(): void {
    this.set({ navigation: null });
  }
}
